import { useParams } from "react-router-dom";
import { useGetOneBlogQuery } from "./blogApiSlice";
import { useState, useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  useAddNewTagMutation,
  useDeleteTagMutation,
  useGetTagQuery,
} from "./useTagApiSlice";
import { useAddNewBlogMutation, useUpdateBlogMutation } from "./blogApiSlice";

const BlogIzmeni = () => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [author, setAuthor] = useState("Veljko");
  const [date, setDate] = useState();
  const [tags, setTags] = useState([]); // Lista svih tagova
  const [newTag, setNewTag] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);

  const [postImage, setPostImage] = useState(); //Mozda bez myFile
  const [isPrivate, setIsPrivate] = useState();

  const { id } = useParams();
  const { isKlijent, isAdmin } = useAuth();

  // Za učitavanje jednog bloga
  const {
    isSuccess: isSuccessGetBlog,
    isError: isErrorGetBlog,
    error: errorBlogError,
    data: getBlogData,
  } = useGetOneBlogQuery(id);

  // Za učitavanje svih tagova
  const {
    data: allTags,
    isSuccess: isSuccessGetTags,
    isError: isErrorGetTags,
    error: getTagError,
  } = useGetTagQuery();

  // Za dodavanje tagova
  const [
    addTag,
    {
      isSuccess: isSuccessAddTag,
      isError: isErrorAddTag,
      error: errorAddTag,
      data: dataAddTag,
    },
  ] = useAddNewTagMutation();

  // Za brisanje tagova
  const [
    deleteTag,
    {
      isSuccess: isSuccessDeleteTag,
      isError: isErrorDeleteTag,
      error: errorDeleteTag,
      data: dataDeleteTag,
    },
  ] = useDeleteTagMutation();

  // Za UPDEJTOVANJE bloga
  const [
    addBlog,
    {
      isSuccess: isSuccessAddBlog,
      isError: isErrorAddBlog,
      error: errorAddBlog,
      data: dataAddBlog,
    },
  ] = useUpdateBlogMutation();

  useEffect(() => {
    if (isSuccessGetBlog) {
      setTitle(getBlogData.title);
      setBody(getBlogData.body);
      setAuthor(getBlogData.author);
      setTags(getBlogData.tags);
      setDate(getBlogData.date);
      setPostImage(getBlogData.slika);
      setIsPrivate(getBlogData.tip === "true");

      // Postavi tagove koji treba da budu označeni
      setSelectedTags(getBlogData.tags || []);

      console.log("Blogg => ", getBlogData);
    }

    if (isErrorGetBlog) {
      alert(errorBlogError?.data?.message);
    }
  }, [isSuccessGetBlog, isErrorGetBlog, errorBlogError, getBlogData]);

  // Učitavanje tagova i postavljanje u stanje
  useEffect(() => {
    if (isSuccessGetTags) {
      if (allTags?.entities) {
        setTags(Object.values(allTags.entities));
      } else {
        console.error("No tags found in allTags.entities", allTags);
      }
    }

    if (isErrorGetTags) {
      alert(getTagError?.data?.message);
    }
  }, [isSuccessGetTags, isErrorGetTags, getTagError, allTags]);

  //
  useEffect(() => {
    if (isSuccessAddBlog) {
      alert(dataAddBlog.message.toString());
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorAddBlog) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorAddBlog?.data?.message);
    }
  }, [isSuccessAddBlog, isErrorAddBlog, errorAddBlog, dataAddBlog]);

  const handleSwitchChange = () => {
    setIsPrivate(!isPrivate);
  };

  const handleTagChange = (event, tag) => {
    if (event.target.checked) {
      setSelectedTags((prevSelectedTags) => [...prevSelectedTags, tag.naziv]);
    } else {
      setSelectedTags((prevSelectedTags) =>
        prevSelectedTags.filter((t) => t !== tag.naziv)
      );
    }
  };

  const handleAddTag = async (e) => {
    e.preventDefault();
    try {
      await addTag({ naziv: newTag });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  const handleDeleteTag = async (id) => {
    try {
      await deleteTag({ id: id });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const base64 = await convertToBase64(file);
      setPostImage(base64);
    }
  };

  const handleAddBlog = async (e) => {
    e.preventDefault();
    try {
      await addBlog({
        id,
        title,
        tags: selectedTags,
        body,
        author,
        date,
        slika: postImage, //.myfile
        tip: isPrivate ? "true" : "false",
      });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  return (
    <>
      <br />
      {getBlogData && (
        <div className="create max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-md">
          <h1 className="text-2xl font-bold mb-4">Izmeni postojeci blog:</h1>
          <form onSubmit={handleAddBlog}>
            <div className="mb-4">
              <label className="block text-lg font-medium mb-2">
                Blog naslov:
              </label>
              <input
                type="text"
                required
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 mb-4"
              />
            </div>

            <div className="flex items-center space-x-4 mb-4">
              <span className="text-lg font-semibold">
                {isPrivate ? "Privatan" : "Javan"}
              </span>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="sr-only"
                  checked={isPrivate}
                  onChange={handleSwitchChange}
                />
                <span
                  className={`w-10 h-5 bg-gray-300 rounded-full transition-colors duration-300 ease-in-out 
                  ${isPrivate ? "bg-green-500" : "bg-gray-400"}`}
                >
                  <span
                    className={`w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-300 ease-in-out
                    ${isPrivate ? "translate-x-5" : "translate-x-1"}`}
                  ></span>
                </span>
              </label>
            </div>

            <div className="mb-4">
              <label className="block text-lg font-medium mb-2">
                Kreiraj nov tag:
              </label>
              <div className="flex items-center gap-2">
                <input
                  type="text"
                  value={newTag}
                  onChange={(e) => setNewTag(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  placeholder="Unesite novi tag"
                />
                <button
                  onClick={handleAddTag}
                  className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                >
                  Dodaj Tag
                </button>
              </div>
            </div>

            <div className="mb-4">
              <label className="block text-lg font-medium mb-2">
                Izaberi tag:
              </label>
              <div className="flex flex-wrap gap-4">
                {isSuccessGetTags && allTags?.entities ? (
                  Object.values(allTags.entities).map((tag, index) => (
                    <div className="flex items-center" key={index}>
                      <label className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          value={tag.naziv}
                          checked={selectedTags.includes(tag.naziv)} // Proverava da li je tag u listi
                          className="form-checkbox"
                          onChange={(event) => handleTagChange(event, tag)}
                        />
                        {tag.naziv}
                      </label>
                      <button
                        className="ml-2 text-red-500 hover:text-red-700"
                        onClick={() => handleDeleteTag(tag._id)}
                      >
                        X
                      </button>
                    </div>
                  ))
                ) : (
                  <p>No tags available.</p>
                )}
              </div>
            </div>

            <div className="mb-4">
              <ReactQuill
                value={body}
                onChange={(value) => setBody(value)}
                className="w-full focus:outline-none focus:ring-2 focus:ring-indigo-500 h-80"
                theme="snow"
              />
            </div>
            <br />
            <br />
            <div className="mb-4">
              <label className="block text-lg font-medium mb-2">
                Blog autor:
              </label>
              <input
                type="text"
                required
                value={author}
                onChange={(e) => setAuthor(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>

            <div className="mb-4">
              <label className="block text-lg font-medium mb-2">
                Otpremi sliku:
              </label>
              <input
                type="file"
                accept=".jpeg, .png, .jpg"
                onChange={handleFileUpload}
                className="block w-full text-sm text-gray-500 file:py-2 file:px-4 file:border file:border-gray-300 file:rounded-md file:bg-blue-500 file:text-white hover:file:bg-blue-600"
              />
            </div>

            {postImage && (
              <div className="mb-4">
                <label className="block text-lg font-medium mb-2">Slika:</label>
                <img
                  src={postImage}
                  alt="Neka slika ovde"
                  className="w-full h-auto rounded-md shadow-sm"
                />
              </div>
            )}

            <div className="mt-6">
              <button
                type="submit"
                className="w-full py-2 bg-yellow-500 text-white rounded-md hover:bg-yellow-600"
              >
                Izmeni Blog
              </button>
            </div>
          </form>
        </div>
      )}
      <br />
      <br />
      <br />
      <br />
    </>
  );
};

export default BlogIzmeni;

function convertToBase64(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => resolve(fileReader.result);
    fileReader.onerror = (error) => reject(error);
  });
}
